import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography
  } from "@mui/material";

interface ParticipantsPaginationProps {
  page: number;
  rowsPerPage: number;
  totalItems: number;
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (newRowsPerPage: number) => void;
}

export default function ParticipantsPagination({
  page,
  rowsPerPage,
  totalItems,
  onPageChange,
  onRowsPerPageChange,
}: ParticipantsPaginationProps) {
  const totalPages = Math.ceil(totalItems / rowsPerPage);
  const startItem = page * rowsPerPage + 1;
  const endItem = Math.min((page + 1) * rowsPerPage, totalItems);

  const handlePreviousPage = () => {
    if (page > 0) {
      onPageChange(page - 1);
    }
  };

  const handleNextPage = () => {
    if (page < totalPages - 1) {
      onPageChange(page + 1);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 2,
        py: 2,
        px: { xs: 2, sm: 3 },
        borderTop: "1px solid #e5e7eb",
        backgroundColor: "#f9fafb",
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
      }}
    >
      {/* Informacje o paginacji */}
      <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.875rem" }}>
        {totalItems > 0 ? `${startItem}-${endItem} z ${totalItems}` : "Brak danych"}
      </Typography>

      {/* Kontrolki paginacji */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {/* Wybór liczby wierszy na stronę */}
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel>Na stronę</InputLabel>
          <Select
            value={rowsPerPage}
            label="Na stronę"
            onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
          >
            <MenuItem value={15}>15</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </FormControl>

        {/* Przyciski nawigacji */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Button
            variant="outlined"
            size="small"
            onClick={handlePreviousPage}
            disabled={page === 0}
            sx={{
              py: 0.5,
              px: 1.5,
              fontSize: "0.75rem",
              minWidth: "auto",
            }}
          >
            Poprzednia
          </Button>

          <Typography variant="body2" sx={{ px: 1, fontSize: "0.875rem" }}>
            {page + 1} z {totalPages}
          </Typography>

          <Button
            variant="outlined"
            size="small"
            onClick={handleNextPage}
            disabled={page >= totalPages - 1}
            sx={{
              py: 0.5,
              px: 1.5,
              fontSize: "0.75rem",
              minWidth: "auto",
            }}
          >
            Następna
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
